"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = void 0;
var constant_1 = require("../../../../constant");
var style_1 = require("../../../../style");
var constants_1 = require("./constants");
var buildOptions = function (_a) {
    var direction = _a.direction, xAxisTitle = _a.xAxisTitle, yAxisTitle = _a.yAxisTitle, stacking = _a.stacking, onClick = _a.onClick, categories = _a.categories, series = _a.series, theme = _a.theme;
    var options = {
        chart: {
            type: direction === 'vertial' ? 'column' : 'bar',
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                pointWidth: 32,
                stacking: stacking,
            },
            series: {
                events: {
                    click: onClick,
                },
            },
        },
        yAxis: {
            labels: {
                style: {
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'center',
                    color: style_1.DesignSystemThemeColor.Gray.DEFAULT,
                },
            },
            min: 0,
            gridLineWidth: 1,
            gridLineColor: style_1.DesignSystemThemeColor.Gray.LIGHT_4,
            title: yAxisTitle ? {
                text: yAxisTitle,
                style: {
                    fontWeight: '600',
                    fontSize: '12px',
                    textAlign: 'center',
                    color: style_1.DesignSystemThemeColor.Gray.DEFAULT,
                },
            } : undefined,
        },
        xAxis: {
            labels: {
                style: {
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'right',
                    color: style_1.DesignSystemThemeColor.Gray.DEFAULT,
                },
            },
            title: xAxisTitle ? {
                text: xAxisTitle,
                style: {
                    fontWeight: '600',
                    fontSize: '12px',
                    textAlign: 'center',
                    color: style_1.DesignSystemThemeColor.Gray.DEFAULT,
                },
            } : undefined,
            type: 'category',
            categories: categories,
        },
        legend: {
            verticalAlign: 'top',
        },
        series: series,
    };
    if (theme.name === constant_1.DESIGN_SYSTEM) {
        options.colors = constants_1.BAR_CHART_COLORS;
    }
    return options;
};
exports.buildOptions = buildOptions;
